export function track(event) {
  const dataLayer = window.dataLayer || []
  console.debug(`Event Tracking: ${JSON.stringify(event)}`)
  dataLayer.push(event)
}
